import React from 'react';
import { LikeHeart as HeartOutline, ThumbUp as ThumbUpOutline, } from '@wix/wix-ui-icons-common/on-stage';
import { AnimatedWrapper } from './animated-wrapper';
import { st, classes } from './like-button.st.css';
import ThumbUp from '../../reaction-icon/icons/thumbs-up-icon';
import Heart from '../../reaction-icon/icons/heart-icon';
import { unreachable } from '../../../ts-utils';
import { ReactionCodeValue } from '../../reaction-types';
import { IS_LIKED, LIKE_BUTTON, LIKE_TEXT } from '../../data-hooks';
import classNames from 'classnames';
import cssVars from '../../styles/css-vars.scss';
export const LikeButton = ({ className, config, activeReaction, isMobile, t, isDisabled, onClick, likeButtonText, }) => {
    const isLiked = activeReaction === ReactionCodeValue.LIKE;
    return (React.createElement("div", { className: st(classes.root, { defaultCursor: !!isDisabled, isMobile, isDisabled }, cssVars.reactionsContainer, className), onClick: isDisabled ? undefined : () => onClick(ReactionCodeValue.LIKE) },
        React.createElement("button", { onClick: (event) => {
                if (isDisabled) {
                    event.preventDefault();
                }
            }, className: st(classes.likeButton, { isLiked }), "aria-label": isLiked ? t('like-button.is-liked') : t('like-button.is-unliked'), "data-hook": classNames(LIKE_BUTTON, isLiked && IS_LIKED) }, (() => {
            switch (config.mainEmotion) {
                case 'thumbsup':
                    return (React.createElement(AnimatedWrapper, { className: st(classes.iconContainer), isActive: isLiked, color: "#FFCD00" }, isLiked ? (React.createElement(ThumbUp, { style: { width: '20px', marginBottom: '3px' } })) : (React.createElement(ThumbUpOutline, { className: classes.iconOutline, style: { marginBottom: '3px' } }))));
                case 'heart':
                case undefined:
                    return (React.createElement(AnimatedWrapper, { className: st(classes.iconContainer), isActive: isLiked, color: "#F5592D" }, isLiked ? (React.createElement(Heart, { style: { width: '20px' } })) : (React.createElement(HeartOutline, { className: classes.iconOutline }))));
                default:
                    unreachable(config.mainEmotion);
            }
        })()),
        React.createElement("span", { className: classes.actionTitle, "data-hook": LIKE_TEXT }, likeButtonText ?? t('like-button.like'))));
};
//# sourceMappingURL=like-button.js.map